module.exports = __webpack_public_path__ + "img/1676356895660-Screenshot_2023-02-14-14-41-02-27_1c337646f29875672b5a61192b9010f9.jpg.d111e483.webp";